import PropTypes from 'prop-types';
import styled from 'react-emotion';

const Hr = styled.hr`
  margin: 16px 0;
  display: block;
  border: 0 solid;
  border: ${props => `0 solid ${props.bg}`};
  border-top-width: 1px;
`;

Hr.propTypes = {
  bg: PropTypes.string,
};

Hr.defaultProps = {
  bg: 'rgb(227, 227, 227)',
};

export default Hr;



// WEBPACK FOOTER //
// ../sthzgnet-branding/lib/Hr/Hr.jsx